import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { AssetContainer } from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/styledComponents";

export const BlankGrid = styled(AssetContainer)`
    background-color: ${colorsPalettes.bluegrey[100]}80;
    border: none;
    pointer-events: none;
`;
